{
    "Accessibility Menu": "Přístupnostní menu",
    "Reset settings": "Obnovit nastavení",
    "Close": "Zavřít",
    "Content Adjustments": "Úpravy obsahu",
    "Adjust Font Size": "Nastavit velikost písma",
    "Highlight Title": "Zvýraznit nadpis",
    "Highlight Links": "Zvýraznit odkazy",
    "Readable Font": "Čitelný font",
    "Color Adjustments": "Nastavení barev",
    "Dark Contrast": "Tmavý kontrast",
    "Light Contrast": "Světlý kontrast",
    "High Contrast": "Vysoký kontrast",
    "High Saturation": "Vysoká saturace",
    "Low Saturation": "Nízká saturace",
    "Monochrome": "Monochromatický",
    "Protanopia": "Protanopie",
    "Deuteranopia": "Deuteranopie",
    "Tritanopia": "Tritanopie",
    "Visual & Navigation Aids": "Vizuální a navigační pomůcky",
    "Additional Tools": "Další nástroje",
    "Reading Guide": "Průvodce čtením",
    "Stop Animations": "Zastavit animace",
    "Big Cursor": "Velký kurzor",
    "Screen Reader": "Čtečka obrazovky",
    "Hide Images": "Skrýt obrázky",
    "Image Tooltips": "Tipy k obrázkům",
    "Page Structure": "Struktura stránky",
    "Super Focus": "Super Focus",
    "Magnifier": "Lupa",
    "Increase Font Size": "Zvětšit velikost písma",
    "Decrease Font Size": "Zmenšit velikost písma",
    "Letter Spacing": "Mezery mezi písmeny",
    "Line Height": "Výška řádku",
    "Font Weight": "Tloušťka písma",
    "Dyslexia Font": "Dyslexický font",
    "Language": "Jazyk",
    "Open Accessibility Menu": "Otevřít přístupnostní menu",
    "Accessibility Profiles": "Profily přístupnosti",
    "Seizure Safe Profile": "Bezpečný profil pro epileptiky",
    "Stops animations and reduces color saturation.": "Zastaví animace a sníží sytost barev.",
    "Blind Profile": "Profil pro nevidomé",
    "Activates the screen reader for auditory navigation.": "Aktivuje čtečku obrazovky pro zvukovou navigaci.",
    "Visually Impaired Profile": "Profil pro slabozraké",
    "Enhances contrast and readability for low vision.": "Zlepšuje kontrast a čitelnost pro slabozraké.",
    "ADHD Friendly Profile": "Profil pro ADHD",
    "Reduces distractions for better focus.": "Snižuje rozptýlení pro lepší soustředění.",
    "Cognitive & Learning Profile": "Kognitivní a vzdělávací profil",
    "Helpful tools for reading and comprehension.": "Užitečné nástroje pro čtení a porozumění.",
    "Motor Impaired Profile": "Profil pro motoricky postižené",
    "Optimizes the site for keyboard-only navigation.": "Optimalizuje stránku pro navigaci pouze klávesnicí.",
    "Headings": "Nadpisy",
    "Landmarks": "Orientační body",
    "Links": "Odkazy",
    "Focus element": "Zaměřit prvek",
    "Visit link": "Navštívit odkaz"
}
